import { extendTheme } from "@chakra-ui/react"
import { AppEntityHydrated, webappThemeConfig } from "@jackfruit/common"
import builderConfig from "../../../config/config.json"
import { getColorScales } from "./utils"

export const config = webappThemeConfig

const { primaryColor, secondaryColor } = builderConfig
const { colors, components } = webappThemeConfig
const { primary: defaultPrimary, secondary: defaultSecondary } = colors

const primary = primaryColor ? getColorScales(primaryColor) : defaultPrimary
const secondary = secondaryColor
  ? getColorScales(secondaryColor)
  : defaultSecondary

const themeConfig = {
  ...webappThemeConfig,
  colors: {
    ...colors,
    primary,
    secondary,
  },
  components: {
    ...components,
    Button: {
      ...components.Button,
    },
  },
  styles: {
    global: {
      // portalZIndex (gatsby-config.ts) wraps every Chakra portal - toasts included - in a
      // div with an INLINE z-index:10, so toasts and the fullscreen editor land in sibling
      // stacking contexts and DOM order decides (editor mounts last, wins). Lift the toast
      // portal wrapper above the whole portal band; !important is required to beat the
      // inline style.
      ".chakra-portal-zIndex:has(> [id^='chakra-toast-manager'])": {
        zIndex: "2000 !important",
      },
    },
  },
}

const theme = extendTheme(themeConfig)

export const makeTheme = (appConfig: AppEntityHydrated) => {
  const { colors, components } = webappThemeConfig
  const { primary: defaultPrimary, secondary: defaultSecondary } = colors

  const primary = appConfig?.primaryColor
    ? getColorScales(appConfig.primaryColor)
    : defaultPrimary

  const secondary = appConfig?.secondaryColor
    ? getColorScales(appConfig.secondaryColor)
    : defaultSecondary

  const themeConfig = {
    ...webappThemeConfig,
    colors: {
      ...colors,
      primary,
      secondary,
    },
    components: {
      ...components,
      Button: {
        ...components.Button,
      },
    },
  }
  return extendTheme(themeConfig)
}

export default theme
